var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29105",
    "data-name": "Group 29105",
    transform: "translate(-2867 -680)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1021",
    "data-name": "Ellipse 1021",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(2867 680)",
    fill: "#339081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65290",
    "data-name": "Path 65290",
    d: "M2858.382,729.08l1.191,1.2,2.675-2.632",
    transform: "translate(12.798 -42.964)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.4ae627e6df78cb9718f04f218eec3ebe.svg";
export { ForwardRef as ReactComponent };